import { mapDTO } from '@twistezo/ts-dto-mapper'

import { Schema } from '../../../Sections/MultiAnchorSection/schema'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'workspaceId'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      customStyling,
      displayAfterUserInteraction,
      fullWidthMode,
      showCloseButton,
      singleAdViewTime,
    }: From): To => ({
      customStyling: JSON.parse(customStyling),
      displayAfterUserInteractionEnabled: displayAfterUserInteraction,
      fullWidthModeEnabled: fullWidthMode,
      showCloseButtonEnabled: showCloseButton,
      singleAdViewTime,
    }),
  )
